module.exports = __webpack_public_path__ + "img/onlineToolsImg3.6bc63477.png";